import { useMutation, useQueryClient } from "@tanstack/react-query";
import { createCrm } from ".";

export function useCreateCrm() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationKey: ["crm"],
        mutationFn: createCrm,
        onSuccess: () => {
            queryClient.invalidateQueries({queryKey: ['crm_data']});
            queryClient.invalidateQueries({queryKey: ['crm'], exact: false});
            queryClient.invalidateQueries({queryKey: ['org_crms']});
        }
    });
}
